import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import isModernContextEnabledEnv from '../../utils/isModernContextEnabledEnv';
import LegacyAnalyticsListener from './LegacyAnalyticsListener';
import ModernAnalyticsListener from './ModernAnalyticsListener';
var ExportedAnalyticsListener = function ExportedAnalyticsListener(props) {
  var isModernContext = isModernContextEnabledEnv || fg('analytics-next-use-modern-context_jira');
  return isModernContext ? /*#__PURE__*/React.createElement(ModernAnalyticsListener, props) : /*#__PURE__*/React.createElement(LegacyAnalyticsListener, props);
};
export default ExportedAnalyticsListener;